import MultiEvent from './components/MultiEvent.vue';
import Event from './components/Event.vue';
import NextEvents from './components/NextEvents.vue';
import Results from './components/Results.vue';

export const routes = [
    { path: '/', component: MultiEvent, redirect: '/next-events' },
    { path: '/next-events', component: NextEvents },
    { path: '/categories/:category', component: MultiEvent },
    { path: '/categories/:category/:meetingID', component: MultiEvent },
    { path: '/categories/:category/:meetingID/:eventID', component: Event },
    { path: '/results', component: Results }
]



// WEBPACK FOOTER //
// ./src/routes.js